import React from 'react';
import { roundToHundredth } from '../utils/orderCalculations';

/**
 * OrderSummary Component
 * Displays order total and continue to checkout button
 * Includes shipping notice when applicable
 * Extracted from Order.js for better maintainability and reusability
 */
const OrderSummary = ({ 
    orderTotal,
    teamPrimaryColorHex,
    hasShipping
}) => {
    return (
        <>
            {/* Total and Checkout */}
            <div className="d-flex align-items-center" style={{
                backgroundColor: '#fff',
                padding: '1.5rem',
                borderRadius: '10px',
                border: `2px solid ${teamPrimaryColorHex || '#0e456c'}`
            }}>
                <strong className="h3 col-6" style={{ color: teamPrimaryColorHex || '#0e456c' }}>
                    Total: ${roundToHundredth(orderTotal || 0) === "NaN" ? 0 : roundToHundredth(orderTotal || 0)}
                </strong>
                <button 
                    className="btn btn-lg col-6" 
                    type="submit"
                    style={{
                        backgroundColor: '#0e456c',
                        color: '#fff',
                        border: 'none'
                    }}
                >
                    Continue to checkout
                </button>
            </div>
            
            {/* Shipping Notice */}
            <div className="d-flex mt-2">
                {hasShipping && (
                    <span className="col-6 text-muted" style={{ fontSize: '0.9em' }}>
                        Please note: Shipping costs will be calculated and displayed on the checkout page. 
                        The final amount may vary based on your delivery location and the items in your order.
                    </span>
                )}
            </div>
        </>
    );
};

export default OrderSummary;
